import {
  ButtonProps,
  Icon,
  PrimaryButton,
  SecondaryButton,
  Spacer,
  Text
} from '@dtx-company/shared-components/src'
import Link from 'next/link'
import React from 'react'

type CTAButtonProps = {
  label?: string
  href?: string
  variant?: string
  iconSrc?: string
  iconAlt?: string
} & ButtonProps

export const CTAButton: React.FC<CTAButtonProps> = ({
  label,
  href,
  variant,
  iconSrc,
  iconAlt,
  ...rest
}) => {
  if (!label) return null
  switch (variant) {
    case 'Primary':
      return (
        <PrimaryButton as="a" href={href} target="_blank" px="16px" {...rest}>
          {iconSrc && <Icon src={iconSrc} mr="8px" alt={iconAlt} />}
          {label}
        </PrimaryButton>
      )
    case 'Secondary':
      return (
        <SecondaryButton as="a" href={href} target="_blank" px="16px" {...rest}>
          {iconSrc && <Icon src={iconSrc} mr="8px" alt={iconAlt} />}
          {label}
        </SecondaryButton>
      )
    case 'Tertiary':
      return (
        <Link href={href ?? '/'} passHref legacyBehavior>
          <Text
            as="a"
            display="flex"
            variant="button/general"
            alignItems="center"
            color="primary.flowBlue"
            target="_blank"
            cursor="pointer"
            alignSelf="center"
          >
            {iconSrc && <Icon src={iconSrc} mr="8px" alt={iconAlt} />}
            {label}
            <Spacer ml="10px" />
          </Text>
        </Link>
      )
    default:
      return null
  }
}

export default CTAButton
